import { render, staticRenderFns } from "./AdminListTickets.vue?vue&type=template&id=ec851ea2&"
import script from "./AdminListTickets.vue?vue&type=script&lang=js&"
export * from "./AdminListTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports